export const SELECTAPPLICATION = "SELECTAPPLICATION";
